import React, { useContext, useRef } from 'react';
import T from '../../../../../../../../common/components/T';
import UserContext, { StoreContext } from '../../../../../../../../common/utils/getContext';
import css from './CartWindow.module.scss';
// import classnames from 'classnames';
// import Display from '../../../../../../../../common/components/Display';
import SingleButton from '../../../../../../../../widgets/form/form-control-buttons/SingleButton/SingleButton';
import classNames from 'classnames';

const CartWindow = ({
    // total = 0,
    // totalMain = 0,
    // total_marketing,
    // isMainCurrency,
    // itemLength = 0,
    makeOrder,
    // deleteProducts,
    allow,
    setAllow,
    // responseComisson,
    // container,
    // cartData,
    // delivery
    setActiveStep
}) => {
    const { setShowRegWindow } = useContext(StoreContext);
    const { userToken } = useContext(UserContext);
    const elem = useRef();
    return (
        <div ref={elem} className={css.storeWindowCartInner}>
            <SingleButton
                type='cancel'
                buttonText={<T textName='back' defaultStr='Назад' />}
                clickFunc={() => setActiveStep((s) => s - 1)}
                customButton={{
                    singleButton: css.button
                }}
            />
            <SingleButton
                type='ok'
                buttonText={<T textName='storeOrderCreate-v1' defaultStr='Оплатить' page='/store' />}
                clickFunc={() => {
                    if (allow) {
                        if (!userToken) {
                            setShowRegWindow(true);
                            return;
                        }
                        setAllow(false);
                        makeOrder();
                    }
                }}
                customButton={{
                    singleButton: classNames(css.button, css.buttonPrimary)
                }}
            />
        </div>
    );
};
export default CartWindow;
